//export const USER_ID_DEV = '4C55AE07-AEA6-4961-9CE8-3768128C5537';
export const USER_ID_DEV = '21D6F869-72D3-46E7-8E2B-10B7F8B73263';